<template lang="html">
  <transition-group tag="span" class="has-error help-block error-block text-error" name="fade"
                    v-show="hasErrors"><span
      v-for="(message, idx) in messages" :key="'error' + idx">{{ message }}</span>
  </transition-group>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {ModelErrors} from 'capitalist-shared/src/core/model';

const props = defineProps({
  errors: {
    type: [Object, ModelErrors],
    required: true,
  },
  attribute: {
    type: String,
    required: true,
  },
})

const attributes = computed(() => {
  return props.attribute.split('|');
})

const messages = computed(() => {
  const messages: string[] = [];
  for (const attribute of attributes.value) if (props.errors.has(attribute)) messages.push(props.errors.get(attribute));
  return messages;
})

const hasErrors = computed(() => {
  for (const attribute of attributes.value) if (props.errors.has(attribute)) return true;
  return false;
})
</script>


<style scoped lang="less">
.error-block > span {
  display: block;
}
.error-block {
  font-size: 1.35rem;
}
</style>
